import React from 'react';

import { FileType } from '../../../../../types/common.types';

import { getClassNames, isImage, isVideo } from '../../../../../utils/util';

import { ReactComponent as CloseIcon } from '../../../../../resources/icons/close.svg';
import { ReactComponent as FileIcon } from '../../../../../resources/icons/file.svg';

import './tribe-files.scss';

type Props = {
  files: FileType[];
  downloadFile: (file: FileType) => void;
  deleteFile?: (file: FileType) => void;
  post?: boolean;
  comment?: boolean;
};

const TribeFiles = ({ files, downloadFile, deleteFile, post = false, comment = false }: Props) => {
  const handleFileClick = (file: FileType) => {
    if (file.documentExternalReference) {
      downloadFile(file);
    }
  };

  return (
    <div className={getClassNames('tribe-files', { comment, post })} data-testid="tribe-files">
      {files.map((file, index) => {
        if (isImage(file.name) || isVideo(file.name)) return null;

        return (
          <div className={getClassNames('tribe-files__file', { comment })} key={index}>
            <div
              className={getClassNames('tribe-files__file-icon-container', {
                pointer: file.documentExternalReference && downloadFile
              })}
              onClick={() => handleFileClick(file)}
            >
              <FileIcon className="tribe-files__file-icon" data-testid="tribe-files-file-icon" />
            </div>
            <p>{file.name}</p>
            {deleteFile && (
              <CloseIcon
                className="tribe-files__delete-icon"
                onClick={() => deleteFile(file)}
                data-testid="tribe-files-delete-icon"
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TribeFiles;
